//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['portfolio', 'categories', 'title', 'category'],
    data() {
        return {
            listOfCategories: [],
            currentCategory: null
        }
    },
    beforeMount() {
        this.currentCategory = this.category;
        this.categories.unshift({title: 'Alle', slug: 'alle'});
        for(let i = 0; i < this.categories.length; i++) {
            this.listOfCategories.push(this.categories[i].slug);
        }
    },
    methods: {
        containsCategory(array, text) {
          if(this.currentCategory === 'alle' && text) {
            for(let i = 0; i < array.length; i++) {
              if(array[i].slug) {
                return false;
              }
            }
            return true;
          } else {
            for(let i = 0; i < array.length; i++) {
              if(array[i].slug === this.currentCategory || this.currentCategory === 'alle') {
                return true;
              }
            }
            return false;
          }
        },
        isCurrentCategory(category) { return category === this.currentCategory; },
        setCategory(category) { this.currentCategory = category; }
    }
}



// WEBPACK FOOTER //
// ./scripts/vue/archive-portfolio.vue